<template>
  <div id="users">
    <h1>Utilizadores</h1>
    <input v-model="search" placeholder="Pesquisar..." />
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Username</th>
          <th scope="col">E-mail</th>
          <th scope="col">Tipo</th>
          <th scope="col">Estado</th>
          <th scope="col">Remover</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user in filter" :key="user.id">
          <td>{{ user.username }}</td>
          <td>{{ user.email }}</td>
          <td>
            <span v-if="user.type == 1">Administrador</span>
            <span v-if="user.type == 0">Utilizador</span
            ><button @click="editType(user.id, user.username, user.type)">
              🔄
            </button>
          </td>
          <td>
            <span v-if="user.state == 0">Autorizado</span>
            <span v-if="user.state == 1">Não autorizado</span
            ><button @click="editState(user.id, user.username, user.state)">
              🔄
            </button>
          </td>
          <td>
            <span v-if="user.type == 1"
              ><button id="trash" disabled>🗑️</button></span
            >
            <span v-else
              ><button id="trash" @click="deleteUser(user.id)">
                🗑️
              </button></span
            >
          </td>
        </tr>
      </tbody>
    </table>
    <span v-if="this.total > 1">
      <span v-if="this.currentPage == 1">
        <button @click="prevPage()" disabled>Prev</button></span
      >
      <span v-else>
        <button @click="prevPage()">Prev</button>
      </span>
      {{ currentPage }}/{{ total }}
      <span v-if="this.currentPage == this.total"
        ><button @click="nextPage()" disabled>Next</button></span
      >
      <span v-else> <button @click="nextPage()">Next</button></span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data: function() {
    return {
      users: [],
      search: "",
      currentPage: 1,
      pageSize: 10,
      total: "",
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      try {
        await this.$store.dispatch("fetchUsers");
        this.users = this.getUsers.data;
      } catch (err) {
        this.$swal({
          title: err,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
    async editType(id, name, type) {
      let tipo;
      if (type == 0) {
        tipo = "Administrador";
      } else {
        tipo = "Utilizador";
      }
      try {
        await this.$store.dispatch("putUserType", {
          id: id,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: `Atualizaou ${name} para ${tipo}`,
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.getUser();
    },
    async editState(id, name, state) {
      let estado;
      if (state == 0) {
        estado = "Não Autorizado";
      } else {
        estado = "Autorizado";
      }
      try {
        await this.$store.dispatch("putUserState", {
          id: id,
        });
        this.$swal({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          title: `Atualizaou ${name} para ${estado}`,
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
      this.getUser();
    },
    async deleteUser(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.$store.dispatch("deleteUser", {
              id: id,
            });
          } catch (err) {
            this.$swal({
              title: err.data.status,
              icon: "error",
              confirmButtonText: "Ok!",
            });
          }
          this.getUser();
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    },
    async nextPage() {
      if (this.currentPage * this.pageSize < this.filterCandidates.length)
        this.currentPage++;
    },
    async prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
  },
  computed: {
    ...mapGetters(["getUsers"]),
    filterUsers() {
      return this.users.filter((user) => {
        let filterResult = true;
        if (this.search == "") {
          return filterResult;
        }
        //NOME
        if (user.username.toLowerCase().includes(this.search.toLowerCase())) {
          filterResult = user.username
            .toLowerCase()
            .includes(this.search.toLowerCase());
          return filterResult;
        }
        //EMAIL
        if (user.email.toLowerCase().includes(this.search.toLowerCase())) {
          filterResult = user.email
            .toLowerCase()
            .includes(this.search.toLowerCase());
          return filterResult;
        }
      });
    },
    filter() {
      return this.filterUsers.filter((row, index) => {
        this.total = Math.ceil((index + 1) / this.pageSize);
        let start = (this.currentPage - 1) * this.pageSize;
        let end = this.currentPage * this.pageSize;
        if (index >= start && index < end) return true;
      });
    },
  },
};
</script>
<style scoped>
#users {
  padding: 50px 60px 0px 300px;
}
h1 {
  margin-bottom: 50px;
}
input {
  margin-bottom: 30px;
  border-radius: 5px;
  border: 1px solid silver;
}
button {
  border: none;
  background: none;
}
</style>
